import { render } from "./almacen.vue?vue&type=template&id=704e5f73"
import script from "./almacen.vue?vue&type=script&lang=js"
export * from "./almacen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__